import { Pipe } from '@angular/core';
import { isString } from '../helpers/helpers';
var UcWordsPipe = (function () {
    function UcWordsPipe() {
    }
    UcWordsPipe.prototype.transform = function (text) {
        if (isString(text)) {
            return text.split(' ')
                .map(function (sub) { return sub.slice(0, 1).toUpperCase() + sub.slice(1); })
                .join(' ');
        }
        return text;
    };
    return UcWordsPipe;
}());
export { UcWordsPipe };
UcWordsPipe.decorators = [
    { type: Pipe, args: [{ name: 'ucwords' },] },
];
/** @nocollapse */
UcWordsPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=ucwords.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/string/ucwords.js
// module id = 272
// module chunks = 4